import { h } from 'preact'
import PropTypes from 'prop-types'

const Checkbox = ({ label, inputProps, labelId, labelProps }) => (
  <label
    className="input input-checkbox address-form-toggler"
    id={labelId}
    htmlFor={inputProps.id}
    tabIndex="0"
    {...labelProps}
  >
    <div className="group">
      <input type="checkbox" {...inputProps} />
      <i
        className="icon-checkbox"
        role="checkbox"
        aria-checked={inputProps.checked}
        aria-labelledby={labelId}
      >
        <svg className="icon" width="24px" height="24px" viewBox="0 0 24 24">
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <rect className="fill" x="2" y="2" width="20" height="20" rx="2" />
            <polyline className="stroke" points="7 13 10 16 17 8" />
          </g>
        </svg>
      </i>
      <span className="label-inline">{label}</span>
    </div>
  </label>
)

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  inputProps: PropTypes.object.isRequired,
  labelProps: PropTypes.object,
  labelId: PropTypes.string,
}

export default Checkbox
